import './RAGStatusBadge.css';

export type RAGStatus = 'not_prepared' | 'preparing' | 'ready' | 'failed' | 'restricted' | 'unknown';

interface Props {
  status: string | null | undefined;
}

const normalizeStatus = (status: string | null | undefined): RAGStatus => {
  if (!status) return 'unknown';
  const s = String(status);
  if (s === 'not_prepared') return 'not_prepared';
  if (s === 'preparing') return 'preparing';
  if (s === 'ready') return 'ready';
  if (s === 'failed') return 'failed';
  if (s === 'restricted') return 'restricted';
  return 'unknown';
};

const STATUS_CONFIG: Record<RAGStatus, { label: string; className: string } > = {
  not_prepared: { label: 'RAG: Not prepared', className: 'rag-status-not-prepared' },
  preparing: { label: 'RAG: Preparing…', className: 'rag-status-preparing' },
  ready: { label: 'RAG: Ready', className: 'rag-status-ready' },
  failed: { label: 'RAG: Failed', className: 'rag-status-failed' },
  restricted: { label: 'RAG: Restricted', className: 'rag-status-restricted' },
  unknown: { label: 'RAG: Unknown', className: 'rag-status-unknown' },
};

export default function RAGStatusBadge({ status }: Props) {
  const normalized = normalizeStatus(status);
  const config = STATUS_CONFIG[normalized];

  return (
    <span className={`rag-status-badge ${config.className}`} title={`RAG status: ${normalized}`}>
      {config.label}
    </span>
  );
}
